<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<app-footer></app-footer>

@if (!loading) {
<div class="content-page bg-gray">
    <div class="content p-1">
        <h5 class="px-1 text-capitalize" title="Manage your GPS Devices">Manage GPS Devices</h5>
        <div class="col-md-12 p-1">
            <div class="w-100 rounded">
                <div class="row">
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-header">
                                Devices Inventory
                                @if (gpsProviders && (gpsProviders.length > 0)) {
                                    <button type="button" class="btn btn-sm btn-primary float-right" data-target="#gps-device-modal" data-toggle="modal"><span class="uil-plus"></span></button>
                                }
                            </div>
                            <div class="card-body">
                                <ul class="nav nav-tabs mb-1">
                                    <li class="nav-item">
                                        <a href="#all" data-toggle="tab" aria-expanded="false" class="nav-link active">
                                            <span class="mdi mdi-settings-outline d-md-none d-block"></span>
                                            <span class="d-none d-md-block">All</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#unassigned" data-toggle="tab" aria-expanded="false" class="nav-link">
                                            <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                            <span class="d-none d-md-block">Unassigned</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#assigned" data-toggle="tab" aria-expanded="true" class="nav-link">
                                            <span class="mdi mdi-account-circle d-md-none d-block"></span>
                                            <span class="d-none d-md-block">Assigned</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#inactive" data-toggle="tab" aria-expanded="false" class="nav-link">
                                            <span class="mdi mdi-settings-outline d-md-none d-block"></span>
                                            <span class="d-none d-md-block">Inactive</span>
                                        </a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane show active" id="all">
                                        <ul class="list-group scroll-list">
                                            @for (gpsDevice of gpsDevices; track gpsDevice) {
                                                <li class="list-group-item snapshot-items-all">
                                                    <div>
                                                        Serial Number: {{gpsDevice.serialNumber}}
                                                        <p class="subtitle text-nowrap">{{gpsDevice.integrationCompany.name}} {{gpsDevice.productName}}</p>
                                                    </div>
                                                    <div>
                                                        @if (gpsDevice.status == 'Inactive') {
                                                            <p class="badge badge-danger">{{gpsDevice.status}} </p>
                                                        }
                                                        @if (gpsDevice.status == 'Activated') {
                                                            <p class="badge badge-success">{{gpsDevice.status}}</p>
                                                        }
                                                        @if (gpsDevice.status == 'Assigned') {
                                                            <p class="badge badge-primary">{{gpsDevice.status}} </p>
                                                        }
                                                        @if (gpsDevice.status == 'Unassigned') {
                                                            <p class="badge badge-warning">{{gpsDevice.status}}</p>
                                                        }
                                                    </div>
                                                    <div>
                                                        <button class="btn btn-primary" (click)="editSetup(gpsDevice)">Edit</button>
                                                    </div>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                    <div class="tab-pane" id="unassigned">
                                        <ul class="list-group scroll-list">
                                            @for (unassignedItem of unassigned; track unassignedItem) {
                                                <li class="list-group-item snapshot-items">
                                                    <div>
                                                        {{unassignedItem.serialNumber}}
                                                        <p class="subtitle">{{unassignedItem.integrationCompany.name}}
                                                            {{unassignedItem.productName}}</p>
                                                    </div>
                                                    <div>
                                                        <button class="btn btn-primary" (click)="editSetup(unassignedItem)">Edit</button>
                                                    </div>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                    <div class="tab-pane" id="assigned">
                                        <ul class="list-group scroll-list">
                                            @for (assignedItem of assigned; track assignedItem) {
                                                <li class="list-group-item snapshot-items">
                                                    <div>
                                                        {{assignedItem.serialNumber}}
                                                        <p class="subtitle">{{assignedItem.integrationCompany.name}}
                                                            {{assignedItem.productName}}</p>
                                                    </div>
                                                    <div>
                                                        <button class="btn btn-primary" (click)="editSetup(assignedItem)">Edit</button>
                                                    </div>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                    <div class="tab-pane" id="inactive">
                                        <ul class="list-group scroll-list">
                                            @for (inactiveItem of inactive; track inactiveItem) {
                                                <li class="list-group-item snapshot-items">
                                                    <div class="flex-wrap">
                                                        {{inactiveItem.serialNumber}}
                                                        <p class="subtitle">{{inactiveItem.integrationCompany.name}}
                                                            {{inactiveItem.productName}}</p>
                                                    </div>
                                                    <div>
                                                        <p class="badge badge-primary">
                                                            {{inactiveItem.integrationCompany.name}}</p>
                                                    </div>
                                                    <div>
                                                    </div>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="card">
                            <div class="tab-pane fade show active" id="vehicle-find" role="tabpanel" aria-labelledby="find-tab">
                                <div class="section">
                                    <ul class="nav nav-tabs nav-justified nav-bordered mb-3">
                                        <li class="nav-item">
                                            <a href="#withGPS" data-toggle="tab" aria-expanded="false" class="nav-link active">
                                                <span class="mdi mdi-home-variant d-md-none d-block"></span>
                                                <span class="d-none d-md-block">Inventory with GPS</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="#withoutGPS" data-toggle="tab" aria-expanded="true" class="nav-link">
                                                <span class="mdi mdi-account-circle d-md-none d-block"></span>
                                                <span class="d-none d-md-block">Inventory without GPS</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <div class="tab-content">
                                        <div class="tab-pane show active" id="withGPS">
                                            <gps-inventory-list [hasGPS]="true" (deviceAssigned$)="listenerChildrens($event)" [refresh]="refresh">
                                            </gps-inventory-list>
                                        </div>
                                        <div class="tab-pane" id="withoutGPS">
                                            <gps-inventory-list [hasGPS]="false" (deviceAssigned$)="listenerChildrens($event)" [refresh]="refresh">
                                            </gps-inventory-list>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}


<button type="button" id="gps-device" class="d-none" data-target="#gps-device-modal" data-toggle="modal">&nbsp;</button>
<div class="modal fade" id="gps-device-modal" tabindex="-1" role="dialog" aria-labelledby="gps-device-modal" data-target="#modal">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header m-1 p-1">
                <h5 class="px-1 text-capitalize">Add GPS Device</h5>
                <button type="button" class="close" id="btn-close-modal-gps-device" data-dismiss="modal" aria-label="Close" (click)="resetGPSDeviceInformation()"><span>&times;</span></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="gpsDeviceInformation">
                    <div class="row">
                        <div class="form-group col-md-6 col-sm-12">
                            <label class="text-nowrap" for="integrationCompanyId">Provider</label>
                            <select class="form-control form-control-sm" formControlName="integrationCompanyId">
                                @for (gpsProvider of gpsProviders; track gpsProvider) {
                                    <option [value]="gpsProvider.id">{{gpsProvider.name}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                            <label class="text-nowrap" for="productName">Product Name</label>
                            <input class="form-control form-control-sm" type="text" id="productName" name="productName" formControlName="productName">
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                            <label class="text-nowrap" for="serialNumber">Serial Number</label>
                            <input class="form-control form-control-sm" type="text" id="serialNumber" name="serialNumber" formControlName="serialNumber">
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                            <label class="text-nowrap" for="notes">Notes</label>
                            <textarea class="form-control form-control-sm" type="text" id="notes" name="serialNumber" formControlName="notes"></textarea>
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                            <label class="text-nowrap" for="expiryDate">Expiry Date</label>
                            <input class="form-control form-control-sm" type="date" id="expiryDate" name="expiryDate" formControlName="expiryDate">
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-link btn-sm" data-dismiss="modal" id="btn-close-modal-gps-device" (click)="resetGPSDeviceInformation()"><span class="text-danger">cancel</span></button>
                <button class="btn btn-success" [disabled]="gpsDeviceInformation.invalid" (click)="saveDevice()">Add &amp; Close</button>
            </div>
        </div>
    </div>
</div>